//reorder shop single page elements on responsive
jQuery(window).bind('resize load', function(){
if(jQuery(window).width() < 642) {
//move sections 
jQuery('div#product > .layer > .large-5').insertBefore(jQuery('div#product > .layer > .large-7'));
jQuery('div#product > .layer > .large-7 > .images').insertAfter(jQuery('div#product > .layer > .large-5 > .summary > .product-header'));

}else{
//move em back
jQuery('div#product > .layer > .large-7').insertBefore(jQuery('div#product > .layer > .large-5'));
jQuery('div#product > .layer > .large-7').prepend(jQuery('div#product > .layer > .large-5 > .summary > .images'));	
}
});
  
